/**
 * Front page buttons are outside React App so we need to use vanilla JS
 */

const isDebug = () => {
	return window.location.search.includes('debug');
};

const searchSuggestions = () => {
  const buttons = document.querySelectorAll('.js-generic-search-hero-suggestions a');
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', function(e) {
      const data = {
        'event': 'hakupalkin_pikalinkki',
        'linkinTeksti': e.currentTarget.innerText,
        'linkinUrl': e.currentTarget.href,
        'konteksti': 'hero-alla'
      };
      if (isDebug()) {
        e.preventDefault();
        console.log('push search event', data);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  searchSuggestions();
});
